import {FORM_PATHS, openInModalOrPage} from "../../modals";

export const editMeeting = meeting => dispatch => dispatch(openInModalOrPage(FORM_PATHS.EditMeetingModal, meeting.meetingId, meeting))
